export const uk = {
    'phrases-cell-title': 'Фразы',
    'shows-cell-title': 'Число показов'
};
